import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { headerStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GridOffset } from "@insite/mobius/GridContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.lastUpdateText = mergeToNew(headerStyles.lastUpdateText, {
    css: css`
        @media print {
            display: block;
            font-size: ${fontSizes.medium};
            line-height: ${lineHeights.medium};
            margin-bottom: 4px;
        }
    `,
});

headerStyles.infoGridItem = mergeToNew(headerStyles.infoGridItem, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 8px;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
});

headerStyles.sharingStatus = mergeToNew(headerStyles.sharingStatus, {
    statusText: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-left: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
});

headerStyles.descriptionStyles = mergeToNew(headerStyles.descriptionStyles, {
    heading: {
        size: fontSizes.medium,
        lineHeight: lineHeights.medium,
        color: themeColors.primary.richBlack,
        transform: "capitalize",
        css: css`
            margin-bottom: 4px;
            @media print {
                font-size: ${fontSizes.xSmall};
                line-height: ${lineHeights.xSmall}; 
            }
        `,
    },
    text: {
        color: themeColors.primary.richBlack,
        size: fontSizes.small,
        lineHeight: lineHeights.small,
        css: css`
            @media print {
                font-size: ${fontSizes.xSmall};
                line-height: ${lineHeights.xSmall}; 
            }
        `
    },
});

headerStyles.totalText = mergeToNew(headerStyles.totalText, {
    size: fontSizes.large,
    lineHeight: lineHeights.small,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-left: 0px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
});

headerStyles.tagText = mergeToNew(headerStyles.tagText, {
    css: css`
        background: ${themeBackgrounds.darkGray};
        border-radius: 0;

        :hover {
            background: ${themeColors.primary.richBlack};
        }

        @media print {
            color: ${themeColors.primary.richBlack};
            padding: 0;
        }
    `,
});

headerStyles.container = mergeToNew(headerStyles.container, {
    css: css`
        > ${GridOffset} {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            .imageTopWrapper,
            .wishlist-line-quantity-grid-item {
                padding-left: 0;
            }
            @media print {
                margin: 0;
                > div {
                    padding: 4px 0; 
                }
                * {
                    padding-left: 0;
                    font-size: ${fontSizes.xSmall};
                    margin: 0;
                }
            }
        }
    `
});